<!-- ************************************************************************************************* -->
<div class="wrapper wrapper-content animated fadeInRight ">
  <div class="container-fluid  p-0">
    <div class="row m-t-xs">
      <div class="col-12">
        <span>
          <span class="mx-2" class="leyenda">
            <i class="fa fa-eye" aria-hidden="true"></i> {{ 'Tasks.showing' | translate }} {{ totalFiltered }} de {{
            totalActions }} </span>
        </span>
      </div>
    </div>
    <div class="row m-t-sm">
      <div class="col-12 p-0">
        <input pInputText class="p-inputtext" type="text"
          placeholder="{{ 'Escribe para filtrar acciones' | translate }}" name="filterText" id="filterTextInput"
          [(ngModel)]="filterText" (ngModelChange)="updateFilter()" autocomplete="off" tabindex="1" />
      </div>
    </div>
  </div>
  <div class="container-fluid" *ngIf="filteredClassifiedActions">
    <div *ngFor="let claction of filteredClassifiedActions">
      <div class="titleElement ng-star-inserted"> {{claction.classification}} </div>
      <div class="row m-b-md">
        <div class="col-lg-4 m-t-md" *ngFor="let action of claction.actions">
          <p-panel [toggleable]="true">
            <p-header>
              <span> {{action.name}}</span>
            </p-header>
            <div class="col-12">
              <p [innerHTML]="action.description"></p>
            </div>
            <div class="col-12 m-t-md">
              <button *ngIf="editMode" class="btn btn-sm btn-secondary  m-t-sm" (click)="editAction(action)"
                type="button">
                <i class="fas fa-pencil-alt"></i> {{ 'Actions.modify' | translate }}</button>
              <button class="btn btn-primary btn-sm m-l-md m-t-sm" (click)="execAction (action)" type="button">
                <i class="fa fa-share"></i> {{ 'Actions.execute' | translate }}</button>
              <div>
              </div>
            </div>
          </p-panel>
        </div>
      </div>
    </div>
  </div>
</div>